import React, { useContext, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { FormikContext } from "formik";
import {
  ButtonPrimary,
  Loading,
  SectionContent,
  SelectControl,
} from "../../../../components";
import { envs, links } from "../../../../config";
import { CondicoesGeraisResidencial } from "../../../../forms";
import { useStaticJsonRequest } from "../../../../hooks";
import { distinctArray, mapToOptions } from "../../../../utils";
import * as S from "./CondicoesGerais.Style";

const RESIDENCIAL = "residencial";

const FormDownloadDeContrato = ({ mapeamento, tipoDeSeguroPage }) => {
  const { setFieldValue, values } = useContext(FormikContext);

  useEffect(() => {
    setFieldValue("tipoDeSeguro", tipoDeSeguroPage);
  }, [setFieldValue, tipoDeSeguroPage]);

  const vigenciaOptions = useMemo(() => {
    const vigencias = distinctArray(
      mapeamento
        .filter((item) => item.tipoDeSeguro === RESIDENCIAL)
        .map((i) => i.vigencia)
    );
    return mapToOptions(vigencias);
  }, [mapeamento]);

  useEffect(() => {
    const { vigencia, tipoDeSeguro } = values;
    let item;
    if (values.tipoDeSeguro === RESIDENCIAL) {
      item = {
        ...mapeamento?.find(
          ({ vigencia: v, tipoDeSeguro: ts }) =>
            v === vigencia && ts === tipoDeSeguro
        ),
      };
    } else {
      item = {
        ...mapeamento?.find(({ tipoDeSeguro: ts }) => ts === tipoDeSeguro),
      };
    }
    const { path } = item;
    setFieldValue("seguroLink", path);
  }, [mapeamento, setFieldValue, values]);

  return (
    <S.FormContent>
      <S.ResidencialSelect
        as={SelectControl}
        options={vigenciaOptions}
        name="vigencia"
        label="Vigência"
        placeholder="Selecione"
        tipoDeSeguro={values.tipoDeSeguro}
      />
      <S.DownloadButton
        as={ButtonPrimary}
        disabled={!values.vigencia && values.tipoDeSeguro === RESIDENCIAL}
        label="Baixar condições gerais"
        href={`${envs.hostStaticCdn}${values.seguroLink}`}
        target="_blank"
      />
    </S.FormContent>
  );
};

FormDownloadDeContrato.propTypes = {
  mapeamento: PropTypes.arrayOf(
    PropTypes.shape({
      grupo: PropTypes.string.isRequired,
      consorcio: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
  tipoDeSeguroPage: PropTypes.string.isRequired,
};

const DownloadCondicoesGerais = ({ tipoDeSeguroPage }) => {
  const { data: mapeamento, loading } = useStaticJsonRequest(
    links.residencial.mapaCondicoesGerais
  );

  return (
    <Loading loading={loading}>
      <SectionContent>
        <CondicoesGeraisResidencial
          form={FormDownloadDeContrato}
          mapeamento={mapeamento || []}
          tipoDeSeguroPage={tipoDeSeguroPage}
        />
      </SectionContent>
    </Loading>
  );
};

DownloadCondicoesGerais.propTypes = {
  tipoDeSeguroPage: PropTypes.string.isRequired,
};

export default DownloadCondicoesGerais;
